import { MIN_MAX_AGE } from '@atlassian/jira-router-resources-utils/src/constants.tsx';
import { createResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_BOARDS_DIRECTORY } from './constants.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const boardsDirectoryResource = createResource<any>({
	type: RESOURCE_TYPE_BOARDS_DIRECTORY,
	getKey: () => 'state',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-boards-directory", jiraSpaEntry: "async-resource-boards-directory" */ './controllers/get-data'
		),
	maxAge: MIN_MAX_AGE,
});
